<mat-form-field>
  <input
    matInput
    #dpPicker
    (dateChange)="onDateChange($event)"
    readonly="readonly"
    id="daydateId"
    [matDatepicker]="dp"
    [min]="minDate"
    [max]="tomorrow"
    [formControl]="dayDate"
  />
  <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker
    #dp
    startView="multi-year"
    (yearSelected)="onDateChange($event)"
    (opened)="toggle(dp)"
    (closed)="toggle(dp)"
  ></mat-datepicker>
</mat-form-field>
